<h5>Tarefas para operações</h5>

<div class="container">
  <div ngbAccordion #acc="ngbAccordion" activeIds="ngb-panel-0">

    <div ngbAccordionItem id="ngb-panel-0">
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Importação de Dados</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="bn-form-group col-md-7">
                            <label for="arquivo">Arquivo: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                    ngbTooltip="Informe o arquivo JSON de uma operação exportada"></i></label>
                            <div id="customFile">
                                <input type="file" accept=".json" class="form-control" onclick="this.value = null"
                                    (change)="onFileChange($event)" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <button type="button" class="btn btn-primary" (click)="importarOperacaoCreditoLivre()"> Importar Operação de
                                Crédito Livre
                            </button>
                        </div>
                        <div class="col-md-4">
                            <button type="button" class="btn btn-primary" (click)="importarOperacaoRepasse()"> Importar Operação de
                                Repasse
                            </button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title2">Alterar Estado da Operação</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="col-md-3">
                            <label for="idSh">Id Operação:</label>
                            <input type="text" id="idSh" class="form-control" bnMask="INTEIRO" [(ngModel)]="idOperacaoEstadoOperacao">
                        </div>
                        <div class="col-md-3">
                            <label for="idEstado">Estado:</label>
                            <select id="idEstado" class="form-select" [(ngModel)]="idEstado">
                                <option [ngValue]=null>Todos</option>
                                <option [ngValue]="estado.id" *ngFor="let estado of estados">
                                    {{estado.nome}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary" [disabled]="!idOperacaoEstadoOperacao || !idEstado"
                                (click)="alterarEstadoOperacao()">Alterar</button>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-light" (click)="limparEstadoOperacao()">Limpar</button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

<div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title2">Alterar Estado da Liberação</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="col-md-3">
                            <label for="idOpe">Id Operação:</label>
                            <input type="text" id="idOpe" class="form-control" bnMask="INTEIRO" [(ngModel)]="idOperacaoEstadoOperacao">
                        </div>
                        <div class="col-md-3">
                            <label for="idLiberacao">Número da Liberação:</label>
                            <input type="text" id="idLiberacao" class="form-control" bnMask="INTEIRO" [(ngModel)]="numeroLiberacao">
                        </div>
                        <div class="col-md-4">
                            <label for="idEstadoLiberacao">Estado:</label>
                            <select id="idEstadoLiberacao" class="form-select" [(ngModel)]="idEstadoLiberacao">
                                <option [ngValue]="1">Protocolada</option>
                                <option [ngValue]="2">Aguardando aprovação</option>
                                <option [ngValue]="3">Aprovada sob condição de pagto. ECG</option>
                                <option [ngValue]="4">Reprovada</option>
                                <option [ngValue]="5">Aguardando emissão de cobrança</option>
                                <option [ngValue]="6">Em emissão de cobrança</option>
                                <option [ngValue]="7">Cobrança emitida</option>
                                <option [ngValue]="8">Cancelada</option>
                                <option [ngValue]="9">Concluída</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary" [disabled]="!idOperacaoEstadoOperacao || !numeroLiberacao || !idEstadoLiberacao"
                                (click)="alterarEstadoLiberacao()">Alterar</button>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-light" (click)="limparEstadoLiberacao()">Limpar</button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title2">Alterar Estado do Aditivo</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="col-md-3">
                            <label for="idAditivo">Id Aditivo:</label>
                            <input type="text" id="idAditivo" class="form-control" bnMask="INTEIRO" [(ngModel)]="idAditivo">
                        </div>
                        <div class="col-md-3">
                            <label for="idEstadoAditivo">Estado:</label>
                            <select id="idEstadoAditivo" class="form-select" [(ngModel)]="idEstadoAditivo">
                                <option [ngValue]="1">Validado</option>
                                <option [ngValue]="2">Aprovado</option>
                                <option [ngValue]="3">Reprovado</option>
                                <option [ngValue]="4">Aguardando emissão de cobrança</option>
                                <option [ngValue]="7">Em emissão de cobrança</option>
                                <option [ngValue]="8">Cobrança emitida</option>
                                <option [ngValue]="5">Efetivado</option>
                                <option [ngValue]="6">Cancelado</option>
                                <option [ngValue]="9">Revertido</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary" [disabled]="!idAditivo || !idEstadoAditivo"
                                (click)="alterarEstadoAditivo()">Alterar</button>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-light" (click)="limparEstadoAditivo()">Limpar</button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title2">Alterar Fator K da Operação</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="col-md-3">
                            <label for="idOperacao">Id Operação:</label>
                            <input type="text" id="idOperacao" class="form-control" bnMask="INTEIRO" [(ngModel)]="idOperacaoAjusteFatorK">
                        </div>
                        <div class="col-md-3">
                            <label for="fatorK">Fator K:</label>
                            <input type="text" id="fatorK" class="form-control" bnMask="DECIMAL" [casasDecimais]="2" [(ngModel)]="fatorK">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary" [disabled]="!idOperacaoAjusteFatorK || !fatorK"
                                (click)="alterarFatorK()">Alterar</button>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-light" (click)="limparAlteracaoFatorK()">Limpar</button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title3">Criar SCR</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="col-md-3">
                            <label for="idSh">Id Operação:</label>
                            <input type="text" id="idSh" class="form-control" bnMask="INTEIRO" [(ngModel)]="idOperacaoScr">
                        </div>
                        <div class="col-md-4">
                            <label>Data da Primeira Parcela Inadimplente:</label>
                            <bn-datepicker name="dataParcelaInadimplente" id="dataParcelaInadimplente" ngDefaultControl
                                [(ngModel)]="dataParcelaInadimplente">
                            </bn-datepicker>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary" [disabled]="!idOperacaoScr || !dataParcelaInadimplente"
                                (click)="criaScrValido()">Criar SCR Válido</button>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary" [disabled]="!idOperacaoScr || !dataParcelaInadimplente"
                                (click)="criaScrInvalido()">Criar SCR Inválido</button>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-light" (click)="limparScr()">Limpar</button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title2">Importação de Liberação Repasse</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary" (click)="importarLiberacoes()">Importar</button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title4">Efetivar Contratação de Garantias / Retificação - (Corte periódico)</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary" (click)="efetivarContratacaoGarantiaCorte()">Efetivar</button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title5">Deslocar Operação no Tempo</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="col-md-3">
                            <label for="idOperacaoDeslocarOperacao">Id Operação:</label>
                            <input type="text" id="idOperacaoDeslocarOperacao" class="form-control" bnMask="INTEIRO"
                                [(ngModel)]="idOperacaoDeslocarOperacao">
                        </div>
                        <div class="col-md-2">
                            <label for=" qtdMesesDeslocamento "> Qtde. meses <i class=" fa fa-question-circle help-subtitulo "
                                    placement="top" ngbTooltip="  Qtde. meses deslocamento"></i></label>
                            <input type="number" id="qtdMesesDeslocamento" class="form-control" [(ngModel)]="qtdMesesDeslocamento">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary"
                                [disabled]="!idOperacaoDeslocarOperacao || !qtdMesesDeslocamento"
                                (click)="deslocarOperacaoNoTempo()">Deslocar</button>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-light" (click)="limparDeslocarOperacao()">Limpar</button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title6">Criar Operação de Repasse - formulário básico</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="col-md-3">
                            <label for="sistemaCobranca">Sistema: * </label>
                            <select type="text" id="sistemaCobranca" class="form-select" bnMask="INTEIRO" [(ngModel)]="sistemaCobranca"
                                [required]="true">
                                <option>15</option>
                                <option>89</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label for="contratoCobranca">Contrato: *</label>
                            <input type="text" id="contratoCobranca" class="form-control" bnMask="INTEIRO" minlength="11" maxlength="11"
                                [required]="true" [(ngModel)]="contratoCobranca">
                            <span class="erro" *ngIf=" contratoCobrancaLength() ">O contrato deve possuir 11 dígitos.</span>
                        </div>
                        <div class="col-md-3">
                            <label for="cnpjAgenteFinanceiro">CNPJ Agente Financeiro*: </label>
                            <input type="text" id="cnpjAgenteFinanceiro" class="form-control" bnMask="CNPJ"
                                [(ngModel)]="cnpjAgenteFinanceiro" required="true">
                        </div>
                        <div class="col-md-3">
                            <label for="cnpjClienteFinal">CNPJ Cliente Final: </label>
                            <input type="text" id="cnpjClienteFinal" class="form-control" bnMask="CNPJ" [(ngModel)]="cnpjClienteFinal">
                        </div>
                        <div class="col-md-3">
                            <label>Data Contratação:</label>
                            <bn-datepicker name="dataContratacao" id="dataContratacao" ngDefaultControl [(ngModel)]="dataContratacao">
                            </bn-datepicker>
                        </div>
                        <div class="col-md-3">
                            <label>Data Primeira Amortização:</label>
                            <bn-datepicker name="dataPrimeiraAmortizacao" id="dataPrimeiraAmortizacao" ngDefaultControl
                                [(ngModel)]="dataPrimeiraAmortizacao">
                            </bn-datepicker>
                        </div>
                        <div class="col-md-3">
                            <label>Data Última Amortização:</label>
                            <bn-datepicker name="dataUltimaAmortizacao" id="dataUltimaAmortizacao" ngDefaultControl
                                [(ngModel)]="dataUltimaAmortizacao">
                            </bn-datepicker>
                            <span *ngIf="comparaDatas() && dataUltimaAmortizacao != null" class="erro"> As datas são inválidas!
                            </span>
                        </div>
                        <div class="col-md-3">
                            <label for="valorOperacao">Valor Operação: </label>
                            <input type="text" id="valorOperacao" class="form-control" bnMask="MOEDA" [(ngModel)]="valorOperacao">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary no-margin" [disabled]="habilitaBotao()"
                                (click)="criarOperacaoDeRepasse()">Criar</button>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-light" (click)="limparOperacaoRepasse()">Limpar</button>
                        </div>
                        <div class="col-auto alert alert-warning col-md-9" style="color: black;">
                            Deverá ser<b> primeiro executada a tarefa "Contrato SCC >> Inclusão/Consulta de contrato (ENDI)"</b>,
                            para que não ocorra erro devido a falta de existência do contrato.
                          </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title7">Criar Operação de Repasse - JSON</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="bn-form-group col-md-12">
                            <label>Conteúdo JSON:</label>
                            <textarea rows="10" type="text" id="conteudoJson" class="form-control"
                                [(ngModel)]="jsonOperacao">{{jsonOperacao}}</textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary" (click)="criarJson()">Criar</button>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-light" (click)="limparJson()">Limpar</button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

</div>
</div>